// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.depositbtn-container {
  display: flex;
  max-height: 38px;
}
.depositbtn-container .balance-section {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  align-items: flex-end;
  min-width: 4rem;
  gap: 4px;
  justify-content: center;
}
.depositbtn-container .deposit-icon {
  display: flex;
  flex-direction: column;
}
.depositbtn-container app-deposit-button::ng-deep div, .depositbtn-container app-deposit-button::ng-deep span {
  display: flex;
}
@media screen and (max-width: 576px) {
  .depositbtn-container app-deposit-button::ng-deep a {
    font-size: 0.625rem;
  }
}

h6 {
  font-family: var(--font-secondary);
  margin: 0 !important;
  padding: 0 !important;
  color: var(--ion-color-light);
}

h6 {
  font-weight: bold;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cashier/navbar-deposit/navbar-deposit.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EAGA,gBAAA;AADJ;AAGI;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AADR;AAKI;EACI,aAAA;EACA,sBAAA;AAHR;AAOQ;EACI,aAAA;AALZ;AAQY;EADJ;IAEQ,mBAAA;EALd;AACF;;AAWA;EACI,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;AARJ;;AAWA;EACI,iBAAA;EACA,eAAA;AARJ","sourcesContent":[".depositbtn-container {\r\n    display: flex;\r\n\r\n\r\n    max-height: 38px;\r\n\r\n    .balance-section {\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-right: 10px;\r\n        align-items: flex-end;\r\n        min-width: 4rem;\r\n        gap: 4px;\r\n        justify-content: center;\r\n    }\r\n\r\n\r\n    .deposit-icon {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    app-deposit-button::ng-deep {\r\n        div, span {\r\n            display: flex;\r\n        }\r\n        a {\r\n            @media screen and (max-width: 576px) {\r\n                font-size: 0.625rem;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\nh6 {\r\n    font-family: var(--font-secondary);\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    color: var(--ion-color-light);\r\n}\r\n\r\nh6 {\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
